<ng-container *ngIf="countertops$ | async"></ng-container>
<ng-container *ngIf="action$ | async"></ng-container>

<div class="flex flex-row items-stretch overflow-hidden h-full">
  <div class="basis-[450px] grow-0 shrink-0 overflow-auto p-4">
    <csl-countertop-settings
      [userId]="userId"
      [panelConnectors]="panelConnectors$ | async"
      [disabled]="disabled"
      [showMaterialsPrice]="isShowMaterialsPrice$ | async"
      [currencySymbol]="getCurrencySymbol()"
      [componentsAvailability]="componentsAvailability"
      [showQuantityInStock]="showQuantityInStock$ | async"
      [postformingGroups]="postformingGroups$ | async"
      (valid)="isValidSettings = $event"
      (countertopChange)="countertopChangeHandler($event)"
      (edgeBandingSelectionChange)="edgeBandingSelectionChange($event)"
      (slotSelectionChange)="slotSelectionChange($event.source.selected)">
      <button
        *ngIf="!edit"
        mat-raised-button
        color="accent"
        (click)="addCountertop()"
        [disabled]="disabled || !countertop?.material || !isValidSettings"
        i18n
        >Добавить</button
      >

      <div class="flex flex-row space-x-4" *ngIf="edit">
        <button
          class="flex-auto"
          mat-raised-button
          color="accent"
          (click)="saveCountertop()"
          [disabled]="disabled || !countertop?.material || !isValidSettings"
          i18n
          >Сохранить</button
        >
        <button class="flex-auto" mat-raised-button (click)="stopEditing()" i18n>Отмена</button>
      </div>
    </csl-countertop-settings>
  </div>

  <mat-divider vertical></mat-divider>

  <div class="flex-auto flex flex-col min-w-0 items-stretch p-4 space-y-4">
    <div class="flex flex-row justify-center">
      <mat-button-toggle-group
        class="min-h-12"
        [(ngModel)]="mode"
        value="schema"
        aria-label="Countertop schema mode"
        (change)="render($event.value)">
        <mat-button-toggle value="schema" i18n>Схема</mat-button-toggle>
        <mat-button-toggle value="texture" i18n>Текстура</mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    <div class="flex-auto overflow-hidden">
      <csl-countertop-schema
        (panelSizeChange)="panelSizeChangeHandler($event)"
        (panelSplit)="panelSplitHandler($event)"
        (panelDelete)="panelDeleteHandler($event)"
        (angleSelectorClick)="selectProcessing($event)"
        (linesJointSelectorClick)="selectLinesJoint($event)"
        (clampJointClick)="selectConnector($event)"
        class="schema"
        #schema></csl-countertop-schema>
    </div>
  </div>

  <div class="max-w-md pt-4 w-full">
    <div class="text-xl" i18n>Столешницы</div>
    <csl-countertop-list
      [cslOverlayLoader]="loading$"
      [countertops]="countertops"
      [orderId]="orderId"
      [mode]="disabled ? 'view' : 'edit'"
      [isDisabledItem]="isDisabledItem"
      (editItem)="editCountertop($event)"
      (deleteItem)="deleteCountertop($event)"></csl-countertop-list>
  </div>
</div>
